import { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import { IAccreditation } from "services/models";
import PostTypeFeaturedIcon from "components/PostTypeFeaturedIcon/PostTypeFeaturedIcon";

export interface AccreditationCardProps {
  className?: string;
  accreditation: IAccreditation;
}

const AccreditationCard: FC<AccreditationCardProps> = ({
  className = "h-full",
  accreditation,
}) => {
  const { title, image, description, type } = accreditation;

  const typeColors: Record<IAccreditation["type"], string> = {
    Accreditation: "bg-red-100",
    Membership: "bg-green-100",
    Certificate: "bg-yellow-100",
    Acknowledgment: "bg-blue-100",
  };
  const typeTextColor: Record<IAccreditation["type"], string> = {
    Accreditation: "text-red-800",
    Membership: "text-green-800",
    Certificate: "text-yellow-800",
    Acknowledgment: "text-blue-800",
  };

  const typeColor = "bg-[#f47d20]";
  // const typeText = "bg-gray-500";

  return (
    <div
      className={`nc-Card4 relative flex flex-col-reverse sm:flex-row sm:items-center rounded-[40px] group ${className}`}
      data-nc-id="Card4"
    >
      <div
        className={`block flex-shrink-0 sm:w-56 sm:mr-6 rounded-3xl overflow-hidden mb-5 sm:mb-0`}
      >
        <div className={`block relative aspect-w-16 aspect-h-6`}>
          <NcImage
            src={image}
            alt={title}
            className={`object-contain object-center w-full h-full`}
          />
          <span>
            <PostTypeFeaturedIcon
              className="absolute left-2 bottom-2"
              postType={undefined}
              wrapSize="w-8 h-8"
              iconSize="w-4 h-4"
            />
          </span>
        </div>
      </div>

      <div className="flex flex-col flex-grow">
        <div className="space-y-5 mb-4">
          <div
            className={`text-sm font-medium ${typeColor}   rounded-full px-2 py-1 inline-block mb-2`}
          >
            {type}
          </div>
          <div>
            <h2
              className={`nc-card-title block font-semibold text-neutral-900 dark:text-neutral-100 text-xl`}
            >
              {title}
            </h2>
            <div className="hidden sm:block sm:mt-2">
              <span
                className="text-neutral-500 dark:text-neutral-400 text-base"
                dangerouslySetInnerHTML={{ __html: description }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccreditationCard;
